<template>
    <div v-if="breadcrumbs" :class="['visual-breadcrumbs', modify]">
        <ul class="visual-breadcrumbs__list">
            <li v-for="item in breadcrumbs" class="visual-breadcrumbs__item" :key="item.id">
                <router-link :class="['visual-breadcrumbs__link', {'is-disabled': item.disabled}]"
                             :to="{
                                path: item.link,
                                query: {
                                  ...$route.query.localhost && {localhost: $route.query.localhost},
                                  ...$route.query.innerVisual && {innerVisual: $route.query.innerVisual},
                                  ...$route.query.profitbase && {profitbase: $route.query.profitbase},
                                },
                                hash: '#breadcrumb'}">
                    <span class="visual-breadcrumbs__text">{{item.name}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<style lang='scss'>
    @import "./Breadcrumbs.scss";
</style>

<script>
import iconArrowLeft from '../Icons/icon-arrow-left';
import iconArrowRight from '../Icons/icon-arrow-right';
import {mapGetters} from 'vuex';

export default {
    props: ['modify'],

    components: {
        iconArrowRight,
        iconArrowLeft
    },

    computed: {
        ...mapGetters({
            breadcrumbs: 'GET_BREADCRUMBS',
            dataStep   : 'GET_DATA_STEP'
        })
    },

    methods: {
        goBack() {
            window.history.back();
        }
    }
};
</script>
